import { encryptData, decryptData } from "./encryption";

export const encryptedStorage = {
    getItem: (key) => {
        return new Promise((resolve) => {
            const decrypted = decryptData(key);
            resolve(decrypted ? JSON.stringify(decrypted) : null);
        });
    },
    setItem: (key, value) => {
        return new Promise((resolve) => {
            encryptData(key, JSON.parse(value));
            resolve();
        });
    },
    removeItem: (key) => {
        return new Promise((resolve) => {
            localStorage.removeItem(key);
            resolve();
        });
    },
};
